<template>
  <GridPart
      maxWidth="calc(100% - 80px)"
      :title="title"
      :hasSearch="true"
      :hasFilter="false"
      :hasExtra="true"
      :standardClass="() => {}"
      :extraClass="() => {}"
      :colspan="4"
      empty="Nenašli sa žiadne výkazy."
      itemsKey="ticketItemReports"
      filterKey="TicketItemReport"
      defaultOrder="ticiterep.workedAt"
      defaultBy="DESC"
      :defaultLimit="25"
      :fetchData="fetchData"
  >
    <template
        v-slot:action="{
          init
        }"
    >
      <template
          v-if="TicketItem.ticketItemReportCreatable"
      >
        <CreateTicketItem
            :ticketItemId="TicketItem.id"
            @onCreateTicketItem="(response) => {
              init()

              $emit('refresh', response)
            }"
        />

        &nbsp;
      </template>
    </template>

    <template
        v-slot:search="{
          params,
          errors,
          setSearch
        }"
    >
      <v-text-field
          v-model="params.query"
          :error-messages="errors.query"
          :outlined="true"
          :dense="true"
          hide-details="auto"
          label="Vyhľadávanie"
          :clearable="true"
          @change="setSearch"
      />
    </template>

    <template
        v-slot:list-head="{
          order,
          by,
          orderList,
          byList,
          setOrderBy
        }"
    >
      <th
          class="fixed"
      >
        <OrderList
            orderKey="ticiterep.workedAt"
            :order="order"
            :by="by"
            :orderList="orderList"
            :byList="byList"
            @setOrderBy="setOrderBy"
        />
      </th>

      <th>
        Užívateľ
      </th>

      <th>
        Odpracovaný čas
      </th>

      <th
          class="text-right fixed"
      />
    </template>

    <template
        v-slot:list-body-standard="{
          Item,
          init
        }"
    >
      <td
          class="fixed"
      >
        {{ Item.workedAt|moment('DD.MM.YYYY') }}
      </td>

      <td>
        <TruncateHelper
            :title="Item.User.name"
            maxWidth="300px"
        >
          {{ Item.User.name }}
        </TruncateHelper>
      </td>

      <td>
        {{ Item.timeSpend|number }} h
      </td>

      <td
          class="text-right fixed"
      >
        <template
            v-if="Item.User.id === $store.state.auth.User.id"
        >
          <template
              v-if="Item.updatable"
          >
            <Update
                :id="Item.id"
                @onUpdate="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>

          <template
              v-if="Item.deletable"
          >
            &nbsp;

            <Delete
                :id="Item.id"
                @onDelete="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>
        </template>
      </td>
    </template>

    <template
        v-slot:list-body-extra="{
          Item
        }"
    >
      <td
          :colspan="4"
      >
        <IsEmptyHelper
            :value="Item.note"
            if-no="i"
            if-yes="i"
            empty="bez poznámky"
        >
          {{ Item.note }}
        </IsEmptyHelper>

        <template
            v-if="Item.files.length > 0"
        >
          <template
              v-for="(_File) in Item.files"
          >
            <br
                :key="_File.id + 'br'"
            />

            <a
                :key="_File.id + 'a'"
                :href="$global.axiosUrl() + 'files/'  + _File.token + '/generate/original'"
                target="_blank"
            >
              {{ _File.name }}
            </a>
          </template>
        </template>
      </td>
    </template>
  </GridPart>
</template>

<script>
  import TicketItemReportsAuth from '@/services/ticket-item-reports-auth'

  import CreateTicketItem from '@/components/TicketItemReportsAuth/CreateTicketItem'
  import Update from '@/components/TicketItemReportsAuth/Update'
  import Delete from '@/components/TicketItemReportsAuth/Delete'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketItemReports',
    props: [
      'TicketItem'
    ],
    emits: [
      'refresh'
    ],
    components: {
      Update,
      Delete,
      CreateTicketItem,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper
    },
    data() {
      return {
        title: 'Výkazy'
      }
    },
    methods: {
      fetchData(params) {
        return TicketItemReportsAuth
          .indexTicketItem({
            ticketItemId: this.TicketItem.id,
            params: params
          })
      }
    }
  }
</script>
